import IAppleMusic from '~/assets/icons/social-icons/apple-music.png';
import IDribbble from '~/assets/icons/social-icons/dribbble.png';
import IFacebook from '~/assets/icons/social-icons/facebook.png';
import IFacebookM from '~/assets/icons/social-icons/facebook-messager.png';
import IFlickr from '~/assets/icons/social-icons/flickr.png';
import IGithub from '~/assets/icons/social-icons/github.png';
import IGoogle from '~/assets/icons/social-icons/google.png';
import IInstagram from '~/assets/icons/social-icons/instagram.png';
import ILine from '~/assets/icons/social-icons/line.png';
import ILinkedin from '~/assets/icons/social-icons/linkedin.png';
import IOpenTable from '~/assets/icons/social-icons/open-table.png';
import IPinterest from '~/assets/icons/social-icons/pinterest.png';
import IPostmates from '~/assets/icons/social-icons/postmates.png';
import IReddit from '~/assets/icons/social-icons/reddit.png';
import ISignal from '~/assets/icons/social-icons/signal.png';
import ISkype from '~/assets/icons/social-icons/skype.png';
import ISnapchat from '~/assets/icons/social-icons/snapchat.png';
import ISoundCloud from '~/assets/icons/social-icons/sound-cloud.png';
import ISpotify from '~/assets/icons/social-icons/spotify.png';
import ITelegram from '~/assets/icons/social-icons/telegram.png';
import ITiktok from '~/assets/icons/social-icons/tiktok.png';
import ITripadvisor from '~/assets/icons/social-icons/tripadvisor.png';
import ITrustpilot from '~/assets/icons/social-icons/trustpilot.png';
import ITumblr from '~/assets/icons/social-icons/tumblr.png';
import ITwitter from '~/assets/icons/social-icons/twitter.png';
import IUbereats from '~/assets/icons/social-icons/uber-eats.png';
import IViber from '~/assets/icons/social-icons/viber.png';
import IVimeo from '~/assets/icons/social-icons/vimeo.png';
import IVk from '~/assets/icons/social-icons/vk.png';
import IWeb from '~/assets/icons/social-icons/web.png';
import IWhatsApp from '~/assets/icons/social-icons/whatsapp.png';
import IX from '~/assets/icons/social-icons/x.png';
import IXing from '~/assets/icons/social-icons/xing.png';
import IYelp from '~/assets/icons/social-icons/yelp.png';
import IYoutube from '~/assets/icons/social-icons/youtube.png';

export const SOCIAL_ICON_ITEMS = [
  { icon: IAppleMusic, label: 'Apple Music', value: 'https://music.apple.com', network: 'Apple_Music' },
  { icon: IInstagram, label: 'Instagram', value: 'https://www.instagram.com', network: 'Instagram' },
  { icon: IDribbble, label: 'Dribbble', value: 'https://dribbble.com', network: 'Dribbble' },
  { icon: IFacebook, label: 'Facebook', value: 'https://www.facebook.com', network: 'Facebook' },
  { icon: IFacebookM, label: 'Facebook Messenger', value: 'https://www.messenger.com', network: 'Facebook_Messenger' },
  { icon: IFlickr, label: 'Flickr', value: 'https://www.flickr.com', network: 'Flickr' },
  { icon: IGithub, label: 'GitHub', value: 'https://github.com', network: 'GitHub' },
  { icon: IGoogle, label: 'Google', value: 'https://www.google.com', network: 'Google' },
  { icon: ILine, label: 'Line', value: 'https://line.me', network: 'Line' },
  { icon: ILinkedin, label: 'LinkedIn', value: 'https://www.linkedin.com', network: 'LinkedIn' },
  { icon: IOpenTable, label: 'OpenTable', value: 'https://www.opentable.com', network: 'OpenTable' },
  { icon: IPinterest, label: 'Pinterest', value: 'https://www.pinterest.com', network: 'Pinterest' },
  { icon: IPostmates, label: 'Postmates', value: 'https://postmates.com', network: 'Postmates' },
  { icon: IReddit, label: 'Reddit', value: 'https://www.reddit.com', network: 'Reddit' },
  { icon: ISignal, label: 'Signal', value: 'https://signal.org', network: 'Signal' },
  { icon: ISkype, label: 'Skype', value: 'https://www.skype.com', network: 'Skype' },
  { icon: ISnapchat, label: 'Snapchat', value: 'https://www.snapchat.com', network: 'Snapchat' },
  { icon: ISoundCloud, label: 'SoundCloud', value: 'https://soundcloud.com', network: 'SoundCloud' },
  { icon: ISpotify, label: 'Spotify', value: 'https://open.spotify.com', network: 'Spotify' },
  { icon: ITelegram, label: 'Telegram', value: 'https://web.telegram.org', network: 'Telegram' },
  { icon: ITiktok, label: 'TikTok', value: 'https://www.tiktok.com', network: 'TikTok' },
  { icon: ITripadvisor, label: 'Tripadvisor', value: 'https://www.tripadvisor.com', network: 'Tripadvisor' },
  { icon: ITrustpilot, label: 'Trustpilot', value: 'https://www.trustpilot.com', network: 'Trustpilot' },
  { icon: ITumblr, label: 'Tumblr', value: 'https://www.tumblr.com/', network: 'Tumblr' },
  { icon: ITwitter, label: 'Twitter', value: 'https://twitter.com', network: 'Twitter' },
  { icon: IUbereats, label: 'Uber Eats', value: 'https://www.ubereats.com', network: 'Uber_Eats' },
  { icon: IViber, label: 'Viber', value: 'https://www.viber.com', network: 'Viber' },
  { icon: IVimeo, label: 'Vimeo', value: 'https://vimeo.com', network: 'Vimeo' },
  { icon: IVk, label: 'Vkontakte', value: 'https://vk.com', network: 'Vkontakte' },
  { icon: IWeb, label: 'Website', value: 'https://example.com', network: 'Website' },
  { icon: IWhatsApp, label: 'WhatsApp', value: 'https://www.whatsapp.com/', network: 'WhatsApp' },
  { icon: IX, label: 'X', value: 'https://x.com', network: 'X' },
  { icon: IXing, label: 'Xing', value: 'https://www.xing.com', network: 'Xing' },
  { icon: IYelp, label: 'Yelp', value: 'https://www.yelp.com', network: 'Yelp' },
  { icon: IYoutube, label: 'YouTube', value: 'https://www.youtube.com', network: 'YouTube' },
];

export type SocialIcon = (typeof SOCIAL_ICON_ITEMS)[number];
